var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"empty-wrapper",class:{'show':_vm.show}},[_c('img',{staticClass:"img",style:(`height:${_vm.imgSize}`),attrs:{"src":require("@/assets/user/nodata.png")}}),_c('p',{staticClass:"tips"},[_vm._v(_vm._s(_vm.msg))])])
}
var staticRenderFns = []

export { render, staticRenderFns }